"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.lineHeight = exports.fontSize = exports.spacing = exports.colors = void 0;
var tooltipSizes = {
    smallWidth: "160px",
    smallHeight: "28px",
    mediumWidth: "160px",
    mediumHeight: "80px",
    largeWidth: "200px",
    largeHeight: "120px"
};
exports.colors = {
    primary: "rgba(0, 181, 225, 1)",
    secondary: "rgba(0, 44, 139, 1)",
    success: "rgba(0, 205, 135, 1)",
    warning: "rgba(255, 199, 44, 1)",
    error: "rgba(239, 9, 0, 1)",
    purple: "#7013fe",
    white: "white",
    black: "#00242d",
    black05: "rgba(0, 36, 45, 0.05)",
    black25: "rgba(0, 36, 45, 0.25)",
    black50: "rgba(0, 36, 45, 0.5)",
    black75: "rgba(0, 36, 45, 0.75)"
};
exports.spacing = {
    micro: "0.333rem",
    mini: "0.667rem",
    tiny: "1.333rem",
    small: "2rem",
    med: "2.667rem",
    large: "3.333rem",
    big: "4rem",
    huge: "4.667rem",
    massive: "5.333rem" // 64
};
exports.fontSize = {
    small: "0.833rem",
    caption: "1rem",
    body: "1.167rem",
    subHeader: "1.333rem",
    title: "1.667rem",
    headline: "2rem",
    display: "2.5rem",
    jumbo: "4rem",
    mega: "6rem" // 72
};
exports.lineHeight = {
    small: "1.333rem",
    caption: "1.333rem",
    body: "1.667rem",
    subHeader: "2rem",
    title: "2.667rem",
    headline: "3rem",
    display: "3.333rem",
    jumbo: "5.333rem",
    mega: "8rem" // 96
};
exports.theme = {
    colors: exports.colors,
    buttons: {
        default: {
            bg: "rgba(0, 36, 45, 0.05)",
            text: exports.colors.black,
            pressed: "rgba(0, 36, 45, 0.1)"
        },
        primary: {
            bg: exports.colors.primary,
            text: exports.colors.white,
            pressed: "rgba(0, 181, 225, .8)"
        },
        secondary: {
            bg: exports.colors.secondary,
            text: exports.colors.white,
            pressed: "rgba(0, 44, 139, .85)"
        },
        success: {
            bg: exports.colors.success,
            text: exports.colors.white,
            pressed: "rgba(0, 205, 135, .85)"
        },
        error: {
            bg: exports.colors.error,
            text: exports.colors.white,
            pressed: "rgba(239, 9, 0, .85)"
        },
        warning: {
            bg: exports.colors.warning,
            text: exports.colors.white,
            pressed: "rgba(255, 199, 44, .85)"
        }
    },
    textalign: {
        left: {
            textalign: "left"
        },
        center: {
            textalign: "center"
        },
        right: {
            textalign: "right"
        }
    },
    badges: (_a = {},
        _a["default"] = {
            bg: exports.colors.black25
        },
        _a.primary = {
            bg: exports.colors.primary
        },
        _a.secondary = {
            bg: exports.colors.secondary
        },
        _a.success = {
            bg: exports.colors.success
        },
        _a.purple = {
            bg: exports.colors.purple
        },
        _a.error = {
            bg: exports.colors.error
        },
        _a.warning = {
            bg: exports.colors.warning
        },
        _a.neutral = {
            bg: exports.colors.black
        },
        _a),
    tooltip: {
        simpleSmall: {
            width: tooltipSizes.smallWidth,
            height: tooltipSizes.smallHeight,
            top: "",
            left: "",
            borderColor: "transparent",
            borderWidth: ""
        },
        upSmall: {
            width: tooltipSizes.smallWidth,
            height: tooltipSizes.smallHeight,
            top: "-1.333rem",
            left: "5.8rem",
            borderColor: "transparent transparent rgba(0, 36, 45, 0.9) transparent",
            borderWidth: exports.spacing.mini
        },
        leftSmall: {
            width: tooltipSizes.smallWidth,
            height: tooltipSizes.smallHeight,
            top: "0.583rem",
            left: "-1.25rem",
            borderColor: "transparent rgba(0, 36, 45, 0.9) transparent transparent",
            borderWidth: "0.625rem"
        },
        rightSmall: {
            width: tooltipSizes.smallWidth,
            height: tooltipSizes.smallHeight,
            top: "0.583rem",
            left: "13.333rem",
            borderColor: "transparent transparent transparent rgba(0, 36, 45, 0.9)",
            borderWidth: "0.625rem"
        },
        downSmall: {
            width: tooltipSizes.smallWidth,
            height: tooltipSizes.smallHeight,
            top: "2.333rem",
            left: "6rem",
            borderColor: "rgba(0, 36, 45, 0.9) transparent transparent transparent",
            borderWidth: exports.spacing.mini
        },
        simpleMedium: {
            width: tooltipSizes.mediumWidth,
            height: tooltipSizes.mediumHeight,
            top: "",
            left: "",
            borderColor: "transparent",
            borderWidth: ""
        },
        upMedium: {
            width: tooltipSizes.mediumWidth,
            height: tooltipSizes.mediumHeight,
            top: "-1.333rem",
            left: "6rem",
            borderColor: "transparent transparent rgba(0, 36, 45, 0.9) transparent",
            borderWidth: exports.spacing.mini
        },
        leftMedium: {
            width: tooltipSizes.mediumWidth,
            height: tooltipSizes.mediumHeight,
            top: "2.583rem",
            left: "-1.25rem",
            borderColor: "transparent rgba(0, 36, 45, 0.9) transparent transparent",
            borderWidth: "0.625rem"
        },
        rightMedium: {
            width: tooltipSizes.mediumWidth,
            height: tooltipSizes.mediumHeight,
            top: "2.583rem",
            left: "13.35rem",
            borderColor: "transparent transparent transparent rgba(0, 36, 45, 0.9)",
            borderWidth: "0.625rem"
        },
        downMedium: {
            width: tooltipSizes.mediumWidth,
            height: tooltipSizes.mediumHeight,
            top: "6.666rem",
            left: "6rem",
            borderColor: "rgba(0, 36, 45, 0.9) transparent transparent transparent",
            borderWidth: exports.spacing.mini
        },
        simpleLarge: {
            width: tooltipSizes.largeWidth,
            height: tooltipSizes.largeHeight,
            top: "",
            left: "",
            borderColor: "transparent",
            borderWidth: ""
        },
        upLarge: {
            width: tooltipSizes.largeWidth,
            height: tooltipSizes.largeHeight,
            top: "-1.333rem",
            left: "7.333rem",
            borderColor: "transparent transparent rgba(0, 36, 45, 0.9) transparent",
            borderWidth: exports.spacing.mini
        },
        leftLarge: {
            width: tooltipSizes.largeWidth,
            height: tooltipSizes.largeHeight,
            top: "4.333rem",
            left: "-1.25rem",
            borderColor: "transparent rgba(0, 36, 45, 0.9) transparent transparent",
            borderWidth: "0.625rem"
        },
        rightLarge: {
            width: tooltipSizes.largeWidth,
            height: tooltipSizes.largeHeight,
            top: "4.333rem",
            left: "16.7rem",
            borderColor: "transparent transparent transparent rgba(0, 36, 45, 0.9)",
            borderWidth: "0.625rem"
        },
        downLarge: {
            width: tooltipSizes.largeWidth,
            height: tooltipSizes.largeHeight,
            top: "10rem",
            left: "7.333rem",
            borderColor: "rgba(0, 36, 45, 0.9) transparent transparent transparent",
            borderWidth: exports.spacing.mini
        }
    }
};
//# sourceMappingURL=index.js.map